var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "15", viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.164 4.811c-.359.667-.11 1.5.558 1.858l4.742 2.554 2.553 4.742a1.372 1.372 0 0 0 2.506-.206l4.09-11.942A1.372 1.372 0 0 0 12.87.074L.928 4.164c-.327.111-.6.343-.764.647zm5.682 3.06l5.993-5.994L1.372 5.461l4.474 2.41zm6.963-5.023L6.816 8.84l2.41 4.474 3.583-10.467z", fill: "#fff" })
  );
});